<template>
  <div>
    <div class="msg-list">
      <div>
        <el-radio
          style="width: 230px;"
          v-for="({label, text}, key) in [options[0], options[2], options[4]]"
          :key="key"
          v-model="customSalaryPercentage"
          :label="label"
          @click="changeSettleType(key)">{{text}}
        </el-radio>
      </div>
      <div>
        <el-radio
          style="width: 230px;"
          v-for="({label, text}, key) in [options[1], options[3], options[5]]"
          :key="key"
          v-model="customSalaryPercentage"
          :disabled="label === -2 && settlementDetail.amount === Infinity"
          :label="label"
          @click="changeSettleType(key)">{{text}}
        </el-radio>
      </div>
    </div>
    <p v-if="customSalaryPercentage === -1">
      <b style="margin-right: 10px;">自定义赏金</b>
      <el-input-number v-model="customSalary"
                       controls-position="right"
                       :min="0.00"
                       :max="customMaxSalary"
                       :precision="2"
                       size="small"
                        style="margin-left: 35px"></el-input-number>
    </p>

    <!-- 中台任务 低于原赏金则需要选择结算理由 -->
    <p v-if="(salaryDetail.reduced_salary !== salary || customSalaryPercentage === -1  || customSalaryPercentage === -2)">
      <b style="margin-right: 10px;"><span style="color: red">*</span> 请选择结算理由</b>
      <el-select class=""
                 v-model="salaryDetail.settle_reason"
                 placeholder="请选择">
        <el-option
          v-for="(item, index) in reasons"
          :key="index"
          :label="item.label"
          :value="item.label">
        </el-option>
      </el-select>
    </p>


<!--  非中台工单 -->
    <!--<p v-if="customSalaryPercentage === -2 && orderDetail.project_platform_type !== '2'">-->
      <!--<b style="margin-right: 10px;">模板预设赏金</b>-->
      <!--<span>{{settlementDetail.amount}}</span>-->
      <!--<span>元</span>-->
    <!--</p>-->

    <!--<div style="margin-top: 10px;" v-if="orderDetail.project_platform_type !== '2'">-->
      <!--<div style="width: 225px;display: inline-block;">-->
        <!--<b>原始赏金</b>-->
        <!--<span>{{salary}}</span>-->
        <!--<span>元</span>-->
      <!--</div>-->
      <!--<div style="width: 225px;display: inline-block;">-->
        <!--<b>最终赏金</b>-->
        <!--<span>{{lastSalary}}</span>-->
        <!--<span>元</span>-->
      <!--</div>-->
    <!--</div>-->

    <!-- 中台工单 -->
    <div style="margin-top: 10px; margin-bottom: 50px">
      <p style="width: 425px;"  v-if="salaryDetail.custom_salary === 0">
        <span>任务原赏金</span>
        <template v-if="hasShowProjectCostUiPermission">
          <span class="salary-float" v-if="salaryDetail.incr_salary === 0">{{salary}}元</span>
          <span class="salary-float" v-if="salaryDetail.incr_salary > 0">{{salaryDetail.origin_salary}}元</span>
        </template>
        <template v-else>
          <span class="salary-float"> * 元</span>
        </template>

      </p>

      <p style="width: 425px;" v-if="salaryDetail.percent === 0 && salaryDetail.custom_salary > 0">
        <span>因<span style="color: red">{{salaryDetail.settle_reason}}</span>获得赏金</span>
        <span class="salary-float" v-if="customSalaryPercentage === -1">{{customSalary}}元</span>
        <!--固定金额 type=2-->
        <span class="salary-float" v-if="customSalaryPercentage === -2 && settlementDetail.type === 2">{{settlementDetail.amount}}元</span>
      </p>

      <p style="width: 425px;" v-if="orderDetail.project_platform_type === '2' && salaryDetail.incr_salary > 0">
        <span>限时加值</span>
        <span class="salary-float">+ {{salaryDetail.incr_salary}}元</span>
      </p>

      <p style="width: 425px;" v-if="salaryDetail.percent > 0 && salaryDetail.percent < 100">
        <span>因{{salaryDetail.settle_reason}}获得的赏金比例</span>
        <span class="salary-float">{{salaryDetail.percent}}%</span>
      </p>

      <p style="width: 425px;" v-if="orderDetail.project_platform_type === '2'">
        <span>平台管理费({{salaryDetail.platform_fee_rate}}%)</span>
        <span class="salary-float">- {{salaryDetail.platform_fee}}元</span>
      </p>
      <hr>
      <p style="width: 425px;">
        <!--<span class="salary-float">实际到账： <b>{{lastSalary}}元</b></span>-->
        <template v-if="hasShowProjectCostUiPermission">
          <span class="salary-float">实际到账： <b>{{salaryDetail.actual_appropriation}}元</b></span>
        </template>
        <template v-else>
          <span class="salary-float">实际到账： <b> * 元</b></span>
        </template>
      </p>
    </div>

  </div>
</template>

<script>

export default {
  mixins: [],
  components: {},
  props: {
    salary: {
      type: Number,
      default: 0,
    },
    // Infinity 表示未开启
    settlementDetail: {
      type: Object,
      default: {amount: 0, type: 0, ratio: 0},
    },
    orderDetail: {
      type: Object,
      default: {},
    }
  },
  data () {
    return {
      customSalary: this.salary,
      customMaxSalary: this.salary,
      customSalaryPercentage: 1,
      options: [
        {
          text: '获得赏金的100%',
          label: 1,
          type: 1,
        },
        {
          text: '获得赏金的75%',
          label: 0.75,
          type: 1,
        },
        {
          text: '获得赏金的50%',
          label: 0.5,
          type: 1,
        },
        {
          text: '获得赏金的25%',
          label: 0.25,
          type: 1,
        },
        {
          text: '自定义赏金',
          label: -1,
          type: 2,
        },
        {
          text: '模板预设赏金',
          label: -2,
          type: 3,
        },
      ],
      reasons: [
        {label: '异常门店'},
        {label: '平台补贴'},
        {label: '任务拒访'},
      ],
      // settle_type 1按原赏金比例2自定义价格3按模板预设金额
      salaryDetail: {
        settle_type: 1,
        settle_reason: '',
        origin_salary: 0, // 原赏金
        custom_salary: 0, // 自定义价格
        incr_salary: 0, // 现加值金额部分
        origin_incr_salary: 0, // 原加值金额
        percent: 0, // 赏金百分比
        platform_fee: 0, // 管理费
        platform_fee_rate: 15, // 管理费率
        reduced_salary: this.salary, // 非加值部分赏金
        actual_appropriation: this.salary // 最终赏金
      }
    }
  },
  computed: {
    // 是否拥有【任务管理-查看工单赏金】的 ui 权限
    hasShowProjectCostUiPermission () {
      return filter.hasPermission(250)
    },
    lastSalary (val) {
      // 普通任务无管理费  中台有管理费 15%
      if (this.orderDetail.project_platform_type === '2') {
        this.salaryDetail.platform_fee_rate = 15
      } else {
        this.salaryDetail.platform_fee_rate = 0
      }
      this.salaryDetail.platform_fee = 0
      this.salaryDetail.percent = 0
      this.salaryDetail.custom_salary = 0
      this.salaryDetail.incr_salary = this.salaryDetail.origin_incr_salary
      let salary = 0
      // 平台管理费
      let fee = 0
      let lastSalary = 0
      // 固定金额
      if (this.customSalaryPercentage === -1) {
        this.salaryDetail.settle_type = 2
        salary = _.round(this.customSalary, 2)
        // 防止除零错误，当 origin_salary 为 0 时，incr_salary 设为 0
        if (this.salaryDetail.origin_salary > 0) {
          this.salaryDetail.incr_salary = _.round(this.salaryDetail.incr_salary * salary / this.salaryDetail.origin_salary, 2)
        } else {
          this.salaryDetail.incr_salary = 0
        }
        fee = (salary + this.salaryDetail.incr_salary) * this.salaryDetail.platform_fee_rate * 0.01
        this.salaryDetail.custom_salary = salary
      // 模板预设
      } else if (this.customSalaryPercentage === -2) {
        this.salaryDetail.settle_type = 3
        salary = _.round(this.settlementDetail.amount, 2)
        // 金额比例
        if (this.settlementDetail.type === 1) {
          this.salaryDetail.percent = this.settlementDetail.ratio * 100
          fee = salary * this.salaryDetail.platform_fee_rate * 0.01
        // 固定金额
        } else if (this.settlementDetail.type === 2) {
          // 防止除零错误，当 origin_salary 为 0 时，incr_salary 设为 0
          if (this.salaryDetail.origin_salary > 0) {
            this.salaryDetail.incr_salary = _.round(this.salaryDetail.incr_salary * salary / this.salaryDetail.origin_salary, 2)
          } else {
            this.salaryDetail.incr_salary = 0
          }
          fee = (salary + this.salaryDetail.incr_salary) * this.salaryDetail.platform_fee_rate * 0.01
          this.salaryDetail.custom_salary = salary
        }
      //  按比例
      } else {
        this.salaryDetail.settle_type = 1
        // customSalaryPercentage 是除100后的百分数
        this.salaryDetail.percent = this.customSalaryPercentage * 100
        salary = _.round(this.salary * this.customSalaryPercentage, 2)
        fee = salary * this.salaryDetail.platform_fee_rate * 0.01
      }
      this.salaryDetail.reduced_salary = salary
      this.salaryDetail.platform_fee = _.round(fee, 2)

      if (this.salaryDetail.custom_salary > 0) {
        lastSalary = _.round(this.salaryDetail.reduced_salary + this.salaryDetail.incr_salary, 2)
      } else {
        lastSalary = this.salaryDetail.reduced_salary
      }
      this.salaryDetail.actual_appropriation = _.round(lastSalary - this.salaryDetail.platform_fee, 2)
      return lastSalary
    },
  },
  watch: {
    lastSalary (salary) {
      this.$emit('change', salary, this.salaryDetail)
    },
  },
  created () {
    if (this.settlementDetail.amount <= this.salary) {
      this.customSalaryPercentage = -2
    }

    if (this.orderDetail.origin_salary > 0) {
      // 若加值任务的模板预设固定金额大于原赏金则最多给原赏金
      if (this.settlementDetail.amount >= this.orderDetail.origin_salary && this.settlementDetail.amount !== Infinity) {
        this.settlementDetail.amount = this.orderDetail.origin_salary
      }
      // 加值任务的自定义金额默认给原赏金
      this.customSalary = this.customMaxSalary = this.orderDetail.origin_salary * 1
      if (this.orderDetail.project_platform_type === '2') {
        // 工单加值部分金额
        this.salaryDetail.origin_incr_salary = this.salaryDetail.incr_salary = _.round(this.orderDetail.salary - this.orderDetail.origin_salary, 2)
      }
    }

    // 原赏金
    this.salaryDetail.origin_salary = this.orderDetail.origin_salary > 0 ? this.orderDetail.origin_salary : this.orderDetail.salary
    this.$emit('change', this.lastSalary, this.salaryDetail)
  },
  updated () {},
  mounted () {},
  destroyed () {},
  methods: {
    changeSettleType (key) {
      this.salaryDetail.settle_type = this.options[key].type
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss"
       scoped>
.salary-float{
  float: right
}
</style>



// WEBPACK FOOTER //
// src/views/question-review/components/ReviewBox/src/CustomSalary.vue